



























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import breadcrumbNav from '@/components/breadcrumb-nav.vue';

@Component({
    components: { breadcrumbNav },
})
export default class TermsPageView extends ListBase {

    get page() {
        return Util.abp.pages.filter(a => {
            return a.id == Util.abp.setting.get('PAGE_TERMS');
        })[0];
    }

    async mounted() {

    }

    created() {

    }
}